<template>
  <div class="mobile-container">
    <!-- 筛选栏 -->
    <div class="filter-bar" style="position: relative; z-index: 50;">
      <el-text class="pay-text">积分兑换</el-text>
      <el-select placeholder="排序" v-model="selectedSort" style="width: 240px">
        <el-option label="默认排序" value="default"></el-option>
        <el-option label="积分从低到高" value="priceAsc"></el-option>
        <el-option label="积分从高到低" value="priceDesc"></el-option>
        <el-option label="销量优先" value="sales"></el-option>
      </el-select>
    </div>

    <!-- 黄金梨商品列表 -->
    <div class="product-grid">
      <div
          v-for="product in filteredProducts"
          :key="product.id"
          class="product-card"
      >
        <!-- 商品图片 -->
        <div class="product-img">
          <el-image
              :src="product.imageUrl"
              fit="cover"
              :preview-src-list="[product.imageUrl]"
              class="product-image"
              lazy
          >
            <template #error>
              <div class="image-fallback">
                <el-icon class="fallback-icon">
                  <Fruits/>
                </el-icon>
                <span>图片加载失败</span>
              </div>
            </template>
          </el-image>
          <!-- 销量标签 -->
          <div class="sales-tag" v-if="product.sales > 0">
            已售 {{ product.sales }}
          </div>
          <!-- 黄金梨专属标签 -->
          <div class="pear-tag">黄金梨专属</div>
        </div>

        <!-- 商品信息 -->
        <div class="product-info">
          <h3 class="product-name">{{ product.name }}</h3>
          <div class="product-price">
            <span class="current-price">{{ product.price }}</span>
            <span class="original-price" v-if="product.originalPrice">¥{{ product.originalPrice.toFixed(2) }}</span>
          </div>
          <div class="product-desc">{{ product.desc }}</div>
        </div>

        <!-- 底部操作按钮-->
        <div class="product-actions">
          <el-button
              size="mini"
              type="primary"
              class="buy-now-btn"
              @click="handleBuyNow(product)"
          >
            积分兑换
          </el-button>
        </div>
      </div>
    </div>
    <div class="bottom-null">

    </div>
    <!-- 无数据提示 -->
    <div class="empty-tip" v-if="filteredProducts.length === 0">
      暂无匹配的黄金梨商品
    </div>
    <!-- 移除模板中的 el-notification 标签（改用函数式调用） -->
  </div>
</template>

<script setup>
import {computed, ref} from 'vue';
import {Fruits} from '@element-plus/icons-vue';
import {ElNotification} from 'element-plus';

// 修复图片导入：确保图片路径正确（如果是 Vue CLI/Vite 项目，路径需符合规范）
// 若图片放在 public/resource 目录下，无需 import，直接用 '/resource/xxx.jpg'
// 若放在 src/resource 目录下，需确保有对应的文件，且导入路径正确
import order8 from '@/resource/order8.jpg';
import order2 from '@/resource/order2.jpg';
import order3 from '@/resource/order3.jpg';
import order6 from '@/resource/order6.jpg';

// 黄金梨商品列表
const productList = ref([
  {
    id: 2,
    name: '黄金梨礼盒装 5斤 送礼首选',
    imageUrl: order8,
    price: "699积分",
    originalPrice: 69.9,
    sales: 235,
    desc: '精美礼盒 | 大果精选 | 甜度≥15° | 顺丰包邮',
    category: 'pear'
  },
  {
    id: 1,
    name: '黄金梨调味料 调味鲜美',
    imageUrl: order3,
    price: "299积分",
    originalPrice: 29.9,
    sales: 568,
    desc: '产地直供 | 脆甜多汁 | 无农药残留 | 坏果包赔',
    category: 'pear'
  },
  {
    id: 3,
    name: '黄金梨果酱 280g*2瓶 无添加',
    imageUrl: order6,
    price: "399积分",
    originalPrice: 39.9,
    sales: 189,
    desc: '纯梨熬制 | 无蔗糖 | 早餐搭档 | 老少皆宜',
    category: 'pear'
  },
  {
    id: 4,
    name: '黄金梨干 100g*3袋 脱水锁鲜',
    imageUrl: order2,
    price: "259积分",
    originalPrice: 25.9,
    sales: 156,
    desc: '无添加防腐剂 | 酸甜可口 | 休闲零食 | 独立包装',
    category: 'pear'
  }
]);

// 筛选条件
const selectedSort = ref('default');
const searchKeyword = ref('');

// 筛选后的商品列表
const filteredProducts = computed(() => {
  let result = [...productList.value];

  // 搜索筛选
  if (searchKeyword.value.trim()) {
    const keyword = searchKeyword.value.trim().toLowerCase();
    result = result.filter(
        product =>
            product.name.toLowerCase().includes(keyword) ||
            product.desc.toLowerCase().includes(keyword)
    );
  }

  // 排序处理
  switch (selectedSort.value) {
    case 'priceAsc':
      result.sort((a, b) => {
        const scoreA = Number(a.price.replace('积分', ''));
        const scoreB = Number(b.price.replace('积分', ''));
        return scoreA - scoreB;
      });
      break;
    case 'priceDesc':
      result.sort((a, b) => {
        const scoreA = Number(a.price.replace('积分', ''));
        const scoreB = Number(b.price.replace('积分', ''));
        return scoreB - scoreA;
      });
      break;
    case 'sales':
      result.sort((a, b) => b.sales - a.sales);
      break;
    default:
      result.sort((a, b) => a.id - b.id);
      break;
  }

  return result;
});

// 积分兑换：改用函数式调用 ElNotification（核心修复）
const handleBuyNow = (product) => {
  // 直接调用 ElNotification，无需模板标签
  ElNotification({
    title: '兑换提示',
    message: `即将为您兑换：${product.name}`,
    type: 'info',
    duration: 2000,
    showClose: true
  });
};
</script>

<style scoped>
/* 页面容器基础样式 */
.mobile-container {
  height: 93vh;
  width: 100vw;
  position: fixed;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  /*background: linear-gradient(to bottom right, #33872B, #d8ffd0);*/
  background-color: #F2F2E8; /* 白色*/
  top: 0;
  left: 0;
  padding-bottom: 20px; /* 底部留空，防止商品被遮挡 */
}

/*!* 筛选栏 *!
.filter-bar {
  background-color: #fff;
  padding: 12px 16px;
  border-radius: 5px;
  margin-bottom: 16px;
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}*/
/* 筛选栏 */
.filter-bar {
  /* 核心：开启Flex布局，子元素自动横向排列 */
  display: flex;
  padding: 5px;
  background-color: #EEDC82;
  align-items: flex-start; /* 垂直顶部对齐 */
  justify-content: center; /* 水平居中对齐 */
  margin-bottom: 10px;
  /*border-radius: 8px;
   margin-bottom: 16px;
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;*/
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

/* 下拉框样式优化 */
:deep(.el-select) {
  --el-select-input-height: 36px;
}

:deep(.el-select-dropdown) {
  width: 240px !important;
}

.pay-text {
  font-weight: bold; /* 加粗 */
  margin-top: -5px;
  margin-right: 30px;
  font-size: 24px;
}

/* 商品网格布局 */
.product-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  margin: 0 2vw;
}

/* 商品卡片 */
.product-card {
  background-color: #fff;
  border-radius: 5px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  height: 100%;
}

/* 商品图片容器 */
.product-img {
  position: relative;
  padding-top: 100%; /* 1:1比例 */
}

.product-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

/* 图片加载失败 */
.image-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: #faf6ed;
  color: #999;
  font-size: 12px;
}

.fallback-icon {
  font-size: 24px;
  color: #ffb800;
  margin-bottom: 8px;
}

/* 标签样式 */
.sales-tag {
  position: absolute;
  top: 8px;
  right: 8px;
  background-color: rgba(255, 59, 48, 0.8);
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 12px;
  z-index: 1;
}

.pear-tag {
  position: absolute;
  top: 8px;
  left: 8px;
  background-color: rgba(255, 184, 0, 0.9);
  color: #fff;
  font-size: 11px;
  padding: 2px 6px;
  border-radius: 12px;
  z-index: 1;
}

/* 商品信息 */
.product-info {
  padding: 12px;
  flex: 1;
  display: flex;
  flex-direction: column;
}

.product-name {
  font-size: 14px;
  font-weight: 500;
  color: #333;
  margin: 0 0 8px 0;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}

.product-price {
  display: flex;
  align-items: baseline;
  margin-bottom: 6px;
}

.current-price {
  font-size: 16px;
  font-weight: 600;
  color: #ff3b30;
  margin-right: 6px;
}

.original-price {
  font-size: 11px;
  color: #999;
  text-decoration: line-through;
}

.product-desc {
  font-size: 11px;
  color: #888;
  margin-top: auto;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

/* 操作按钮 */
.product-actions {
  display: flex;
  padding: 8px 12px;
  border-top: 1px solid #f5f5f5;
}

.buy-now-btn {
  flex: 1;
  background-color: #ffb800 !important;
  border-color: #ffb800 !important;
  border-radius: 8px !important;
  color: #fff !important;
  height: 36px !important;
  font-size: 14px !important;
}

/* 无数据提示 */
.empty-tip {
  text-align: center;
  margin-top: 60px;
  color: #999;
  font-size: 14px;
  padding: 20px;
}

.bottom-null {
  height: 1vh;
}

/* 适配小屏幕 */
@media screen and (max-width: 375px) {
  .product-name {
    font-size: 13px;
  }

  .current-price {
    font-size: 15px;
  }

  .buy-now-btn {
    font-size: 13px !important;
  }
}
</style>